const session_expired = {
    title: 'Session expirée',
    subtitle: "Votre session a peut-être expiré et vous avez été déconnecté. Cliquez sur le bouton ci-dessous pour vous reconnecter à la console d'administration.",
    button: 'Se reconnecter',
};
export default Object.freeze(session_expired);
